<div class="custom-text-editor-container">
    <quill-editor
        id="message"
        [modules]="quillModules"
        [styles]="styles"
        [formats]="['mention']"
        [placeholder]="placeholder" 
        [formControl]="editorControl" 
        [readOnly]="isDisabled"
        (onContentChanged)="onContentChanged($event)"
        (onBlur)="onTouched()"
        #customQuillEditorRef
    >
    </quill-editor>

    <ng-content></ng-content>
</div>